import {
    Box,
    Button,
    Checkbox,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import Layout from "components/structure/Layout";
  import React, { useContext } from "react";
  import { useEffect } from "react";
  import { useState } from "react";
  import CommonService from "services/CommonService";
  import RoleService from "services/RoleService";
  import CheckboxTick from "assets/CheckboxTick.svg";
  import CheckboxUntick from "assets/CheckboxUntick.svg";
  import { AuthData } from "auth/AuthWarpper";
  import { useLocation, useNavigate } from "react-router-dom";
  import { SnackbarContext } from "context/snackBarContext";
  import UserService from "services/UserService";
  import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
  import dayjs from "dayjs";
  import UserCreationService from "services/UserCreationService";
  import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
  import { useTranslation } from "react-i18next";
  
  const EditOtherDelegation = () => {
    const location = useLocation();
    const {t,i18n} = useTranslation()
    const profileOptions = ["Global", "Local"];
    const { user } = AuthData();
    const navigate = useNavigate();
    const { rowData } = location.state || {};
    console.log("🚀 ~ EditOtherDelegation ~ rowData:", rowData)
    const { setOpenAlert, setSeverity, setMessage, handleClose } =
      useContext(SnackbarContext);
    const [userName, setUserName] = useState(rowData?.userName || "");
    const [isActive, setIsActive] = useState(
      rowData?.status === "Active" ? "Active" : "InActive"
    );
  
    const [formData, setFormData] = useState({
      profile: rowData?.batOneId || "",
      fieldTechnician: "",
      role: rowData?.profileId || "",
      serviceNumber: rowData?.serviceNumber || "",
      remarks: rowData?.remarks || "",
      countryCode: rowData?.countryCode || "",
    });
    const [selected, setSelected] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = React.useState(false);
    const [StartDate, setStartDate] = useState(rowData?.startLocal || "");
    const [endDate, setEndDate] = useState(rowData?.endLocal || "");
    const [selectedRoles, setSelectedRoles] = useState(rowData?.delegatedProfiles || []);
  
    const [roleOptions, setRoleOptions] = useState([]);
    const [countries, setCountries] = useState([]);
  
    const fetchRoles = async () => {
      try {
        const response = await RoleService.getActiveRoles();
        if (response.data?.statusCode === 200) {
          setRoleOptions(response.data.response);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };
  
    const fetchCountries = async () => {
      try {
        const response = await CommonService.fetchCountries();
        if (response.data?.statusCode === 200) {
          setCountries(response.data.response);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };
  
    useEffect(() => {
    
      fetchRoles();
      fetchCountries();
    }, []);
  
    const handleChange = (event) => {
      const { name, value } = event.target;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    };
  
    const isAllSelected =
      countries.length > 0 && selected.length === countries.length;
  
    const handleChangeCountry = (event) => {
      const { name, value } = event.target;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        // setErrors({});
        // await validationSchema.validate(formData, { abortEarly: false });
  
        // Constructing the payload object
        const payload = {
          userName: userName,
          active: isActive === "Active" ? true : false,
          batOneId: formData.profile,
          // profileAttribute: formData.profile,s
          serviceNumber: formData.serviceNumber,
          startDate: new Date().toISOString(),
          endDate: StartDate,
          remarks: formData.remarks,
          isDeleted: false,
          email: "",
          profileId: formData.role,
          countryCode: formData.countryCode,
          createdByUser: user.userName,
          modifiedByUser: user.userName,
          createdDateTimeUTC: new Date().toISOString(),
          modifiedDateTimeUTC: new Date().toISOString(),
        };
  
        // userId
  
        // "userName": "Rahul Dutta",
        // "profileId": "99247bae-e30a-4106-b198-e74e2ce55d26",
        // "batOneId": 85189949,
        // "countryCode": "KEN",
        // "email": "rahul.dutta@itcinfotech.com",
        // "active": true,
        // "isDeleted": false,
        // "createdDateTimeUTC": "2024-05-14T09:32:51.543Z",
        // "createdByUser": "ADMIN",
        // "modifiedDateTimeUTC": "2024-10-04T11:19:29.590Z",
        // "modifiedByUser": "Rahul Dutta"
  
        // Make a POST request using Axios
        const response = await UserCreationService.createUserManagement(payload);
        setLoading(false);
        if (response.status === 201) {
          // Show success snackbar
          navigate("/userCreation");
          setSeverity("success");
          setMessage("Added successfully");
          setOpenAlert(true);
        } else {
          console.error("Failed to submit form");
          // Show error snackbar
          setSeverity("error");
          setMessage("Failed to submit form");
          setOpenAlert(true);
        }
      } catch (error) {
        setLoading(false);
        let newError = {};
        if (error?.name && error.name === "ValidationError") {
          error?.inner?.forEach((err) => {
            newError[err.path] = err.message;
            setErrors(newError || error?.message);
            return;
          });
        } else {
          setSeverity("error");
          setMessage(error?.response?.data?.message || error?.message);
          setOpenAlert(true);
        }
      }
    };
  
    const onUpdateDelegation = () => {
          let data = {
            delegation: rowData?.delegationId,
            userName: user?.userName,
            delegatedProfileIds: selectedRoles
          }
          RoleService.updateDelegation(data)
            .then((res) => {
              setMessage("Updated Successfully")
              setOpenAlert(true)
              setSeverity("success")
            //   navigate(`/${rowData?.fromUrl}`)
            navigate(-1)
            })
            .catch((error) => {
              setMessage(error?.response?.data?.message || error?.message)
              setOpenAlert(true)
              setSeverity("error")
              console.error("API call failed:", error);
            })
    
      }
  
    const [profileData, setProfileData] = useState([]);
  
    const handleChangeText = (e) => {
      setFormData({ ...formData, profile: e.target.value });
    };
  
    const [batData, setBatData] = useState(rowData);
    console.log("🚀 ~ EditOtherDelegation ~ batData:", batData)
  
    const [open, setOpen] = useState(false);
  
  
    useEffect(() => {
      const fetchProfileData = async () => {
        if (formData.profile && !rowData?.userId) {
          if(formData.profile.length >7){
            try {
              const response = await UserService.FindAdUser(formData.profile);
  
  
              setBatData(response?.data?.response);
              setUserName(
                `${response?.data?.response?.givenName ?? ""} ${
                  response?.data?.response?.surName ?? ""
                  }`.trim()
              );
  
              // Assuming the response contains a list of options in response.data
            } catch (error) {
              console.error("Error fetching profile data:", error);
              setSeverity("error");
              setMessage("No record found");
              setOpenAlert(true);
            }
          } else {
  
          }
  
        }
      };
  
      fetchProfileData();
    }, [formData.profile]);
  
  
    const toggleIsActive = () => {
      setIsActive((prevIsActive) =>
        prevIsActive === "Active" ? "InActive" : "Active"
      );
    };
  
    const handleChangeDate = (date) => {
      setStartDate(date); // Store the selected date
    };


  
    return (
      <LayoutAccessManagement>
        <Box sx={{ paddingBottom: "150px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "65vh",
              background: "#f0f3f6",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
              padding: "25px",
              borderRadius: "6px",
            }}
          >
            <Box
              sx={{
                background: "#ffffff",
                width: "443px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                borderRadius: "16px",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
              }}
            >
              <TextField
                id="profile"
                label={t("batOneId")}
                value={batData.fromBATID}
                name="profile"
                onChange={handleChangeText}
                fullWidth
                disabled={true}
              ></TextField>
  
              {(batData !== "" || rowData?.userId) && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography>
                  {t("administratorAccess.name")}: 
                    {batData.fromName}
                  </Typography>
                  <Typography>
                  {t("administratorAccess.email")}: {batData?.fromEmail}
                  </Typography>
                </Box>
              )}
                 <TextField
                id="profile"
                label={t("batOneId")}
                value={batData.toBATID}
                name="profile"
                onChange={handleChangeText}
                fullWidth
                disabled={true}
              ></TextField>
  
              {(batData !== "" || rowData?.userId) && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography>
                  {t("administratorAccess.name")}: 
                    {batData.toName}
                  </Typography>
                  <Typography>
                  {t("administratorAccess.email")}: {batData?.toEmail}
                  </Typography>
                </Box>
              )}
              {(batData !== "" || rowData?.userId) && (
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label={t("Role Name")}
                    disabled={true}
                    name="roleName"
                    value={rowData?.roleName || ""}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      style: { fontStyle: 'italic' }
                    }}
                  />
                </Box>
              )}
              {(batData !== "" || rowData?.userId) && (
                <Box>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      sx={{
                        width: { sx: "100%", md: "100% !important", xl: "100%" },
                      }}
                      components={["DatePicker"]}
                    >
                      <DatePicker
                        sx={{
                          width: {
                            sx: "100%",
                            md: "100% !important",
                            xl: "100%",
                          },
                        }}
                        id="startDate"
                        name="startDate"
                        open={open}
                        onClose={() => setOpen(false)}
                        label={t("administratorAccess.startDate")}
                        format="DD/MM/YYYY | HH:mm"
                        value={StartDate ? dayjs(StartDate) : null}
                        onChange={(date) => handleChangeDate(date)}
                        renderInput={(params) => <TextField {...params} />}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                          textField: {
                            onClick: () => setOpen(true),
                          },
                        }}
                        disabled={true}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Box>
              )}
                {(batData !== "" || rowData?.userId) && (
                <Box>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      sx={{
                        width: { sx: "100%", md: "100% !important", xl: "100%" },
                      }}
                      components={["DatePicker"]}
                    >
                      <DatePicker
                        sx={{
                          width: {
                            sx: "100%",
                            md: "100% !important",
                            xl: "100%",
                          },
                        }}
                        id="endDate"
                        name="endDate"
                        open={open}
                        onClose={() => setOpen(false)}
                        label={t("administratorAccess.endDate")}
                        format="DD/MM/YYYY | HH:mm"
                        value={endDate ? dayjs(endDate) : null}
                        onChange={(date) => handleChangeDate(date)}
                        renderInput={(params) => <TextField {...params} />}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                          textField: {
                            onClick: () => setOpen(true),
                          },
                        }}
                        disabled={true}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Box>
              )}
           
              {(batData !== "" || rowData?.userId) && (
                <>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        pb: 2,
                        cursor: "pointer",
                      }}
                      onClick={toggleIsActive}
                    >
                      <img
                        src={
                          isActive === "Active" ? CheckboxTick : CheckboxUntick
                        }
                        alt="checkbox"
                      />
                      <Typography>
                        {isActive === "Active" ? "Active" : "Inactive"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      gap: "20px",
                      color: "#ffffff",
                    }}
                  >
                    <Button
                      sx={{
                        borderRadius: 2,
                        color: "#ffffff",
                        backgroundColor: "#0A3575",
                        fontWeight: 600,
                        height: 54,
                        width: { xs: "100%", md: "156px" },
                        "&:hover": {
                          backgroundColor: "#0A3575",
                        color: "white",

                        },
                      }}
                      disabled={isActive === "Active"}
                      onClick={onUpdateDelegation}
                    >
                      {/* {rowData?.userId ? "Update" : "Submit"} */}
                      {t("update")}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </LayoutAccessManagement>
    );
  };
  
  export default EditOtherDelegation;
  